import React from 'react';
import { Link } from 'react-router-dom';
import { FiHeart } from 'react-icons/fi';
import '../styles/footer.css';
import config from '../config';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Column 1: Brand & Mission */}
                <div className="footer-col footer-brand">
                    <h2>Electrospinning-Data.org</h2>
                    <p>
                        Electrospinning-Data.org is powered by open-source software. Platform content is licensed under <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">CC BY 4.0</a>.<br />
                        Submitted datasets remain the property of their contributors.
                    </p>
                    <div className="footer-social">
                        <a href={config.githubUrl} className="social-icon" aria-label="GitHub" target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-github"></i>
                        </a>
                        <a href="https://linkedin.com" className="social-icon" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-linkedin"></i>
                        </a>
                        <a href={`mailto:${config.supportEmail}`} className="social-icon" aria-label="Email">
                            <i className="bi bi-envelope-fill"></i>
                        </a>
                    </div>
                </div>

                {/* Column 2: About & Support */}
                <div className="footer-col">
                    <h3>About</h3>
                    <div className="footer-links">
                        <Link to="/home">Home</Link>
                        <Link to="/about">About Project</Link>
                        {/* <Link to="/people">People</Link> */}
                        <Link to="/partners">Partners & Support</Link>
                        <Link to="/how-to-cite">How to Cite</Link>
                        <Link to="/publications">Publications</Link>
                        <Link to="/contact">Contact Support</Link>
                    </div>
                </div>

                {/* Column 3: Data & Community */}
                <div className="footer-col">
                    <h3>Data & Tools</h3>
                    <div className="footer-links">
                        <Link to="/dataset">Explore Dataset</Link>
                        <Link to="/virtual-lab">Virtual Lab</Link>
                        <Link to="/dataSubmission">Submit Dataset</Link>
                        <Link to="/community">Get Involved</Link>
                        <a href={config.docsUrl} target="_blank" rel="noopener noreferrer">Documentation</a>
                    </div>
                </div>

                {/* Column 4: Legal & Policy */}
                <div className="footer-col">
                    <h3>Legal</h3>
                    <div className="footer-links">
                        <Link to="/terms">Terms of Use</Link>
                        <Link to="/privacy">Privacy Policy</Link>
                        <Link to="/license">License Agreement</Link>
                        <a href="https://taltech.ee" target="_blank" rel="noopener noreferrer">Tallinn University of Technology (TalTech)</a>
                    </div>
                </div>
            </div>

            {/* Support strip */}
            <div className="footer-support-strip">
                <span className="footer-support-strip-text">
                    Electrospinning-Data.org is a free, open-science platform; your support sustains research and open data.
                </span>
                <Link to="/support" className="footer-support-strip-btn">
                    <FiHeart size={12} style={{ marginRight: '0.3rem', verticalAlign: 'middle' }} />
                    Support the Platform
                </Link>
            </div>

            <div className="footer-bottom">
                <p>&copy; 2026 Electrospinning-Data.org. Maintained by the Research Laboratory for Cognitronics.</p>
                <p>Licensed under <Link to="/license">CC BY 4.0</Link>.</p>
            </div>
        </footer>
    );
};

export default Footer;
